import { render } from "./selectVariantModal.vue?vue&type=template&id=39c13c68&scoped=true"
import script from "./selectVariantModal.vue?vue&type=script&lang=js"
export * from "./selectVariantModal.vue?vue&type=script&lang=js"

import "./selectVariantModal.vue?vue&type=style&index=0&id=39c13c68&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c13c68"]])

export default __exports__